import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import { Box, Typography } from "@mui/material";
import type { FC } from "react";
import { FONT_SIZE, INK } from "../../../theme/tokens";
import { MetaChip } from "../Badges/MetaChip";

/** A source a chat answer was grounded in. `id` is the stable key; `title` is what's shown. */
export interface ChatSourceItem {
	id: string;
	title: string;
}

type Props = {
	/** Already-translated lead-in, e.g. "Based on the guide". */
	label: string;
	sources: ChatSourceItem[];
	dataTestId?: string;
};

/**
 * Citation row for a grounded chat answer: a muted lead-in plus one neutral chip per source. Read-only
 * — the sources are internal knowledge topics, not linkable pages, so this signals provenance ("where
 * this came from"), not navigation. Renders nothing when there are no sources.
 */
export const ChatSources: FC<Props> = ({ label, sources, dataTestId }) => {
	if (sources.length === 0) return null;
	return (
		<Box data-testid={dataTestId} sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 0.5, mt: 0.75 }}>
			<Typography component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.25, fontSize: FONT_SIZE.SECONDARY, color: INK.MUTED }}>
				<MenuBookOutlinedIcon aria-hidden sx={{ fontSize: FONT_SIZE.SECONDARY }} />
				{label}
			</Typography>
			{sources.map((source) => (
				<MetaChip key={source.id} label={source.title} tone="neutral" size="small" />
			))}
		</Box>
	);
};
